import React from "react";
import "./styles/News.css"

export class News extends React.Component{
    render() {
        return(
            <div className="news"></div>
        )
    }
}